

// material-ui
import { Box, CardMedia } from '@mui/material';
import './index.css'
import { useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import logo from '../../../../assets/images/logos/Group 1000002184.svg'

// third-party

// project imports

// assets

// styles






// ==============================|| SEARCH INPUT - MOBILE||============================== //



// ==============================|| SEARCH INPUT ||============================== //

const SearchSection = (props) => {

  const Nav = useNavigate()


  return (
    <>
      <Box sx={{ marginLeft: 5, display: props.visible ? 'flex' : 'none' }} onClick={() => Nav("/dashboard/default")}>
        {/* <Typography className='roboto-regular' variant='h2'><span style={{fontSize:"29px",fontWeight:900,color:"#592375"}}>Network</span> <span style={{fontSize:"18px",color:"#688B2A",fontWeight:700}}>Manager</span></Typography> */}
        <Link to="#">
          {/* <Logo /> */}
          {/* <Typography color={theme.palette.secondary.main} gutterBottom variant={matchDownSM ? 'h3' : 'h2'}>
                              Network Manager
                            </Typography> */}
          <CardMedia component='img' image={logo} alt='logo' width='20%' />
        </Link>
      </Box>
    </>
  );
};

export default SearchSection;
